// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2BoOk","list":"BalanceDue_list__112V5","listRow":"BalanceDue_listRow__Z19Uc","total":"BalanceDue_total__1LZ3I"};